import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useModals } from "src/components/Modals";
import { duplicateMerchflowModalAtom } from "./atoms";

export const useDuplicateMerchflowModal = () => {
  const { openModal } = useModals();
  const setData = useSetAtom(duplicateMerchflowModalAtom);

  useEffect(() => {
    setData(null);
  }, []);

  const openDuplicateMerchflowModal = (data: {
    id: number;
    name: string;
    onSuccess?: () => void;
  }) => {
    setData(data);
    openModal("ModalDuplicateMerchflow");
  };

  return { openDuplicateMerchflowModal };
};
